import { combineReducers } from 'redux';
import RecentJobsReducer from './CustomCards/RecentJobs/RecentJobsReducer';
import JobPricingStatus from './CustomCards/Common/JobPricingStatusState';
import JobMatching from './CustomCards/Common/JobState';
import MarketIndex from './CustomCards/Common/MarketIndexState';
import OrganizationStatistics from './CustomCards/Common/OrganizationStatisticsState';
import RecentReports from './CustomCards/Common/RecentReportsState';
import SurveyActivity from './CustomCards/Common/SurveyActivityState';
import SurveyUtilization from './CustomCards/Common/SurveyUtilizationState';

import {
  GET_DASHBOARD_VIEWS,
  GET_DASHBOARD_VIEWS_SUCCESS,
  GET_DASHBOARD_VIEWS_ERROR,
  GET_DASHBOARD_SUCCESS
} from './LandingDashboardActions';

const initialState = {
  views: [],
  currentLayout: [],
  currentView: {},
  defaultView: {},
  viewError: false,
  viewSuccess: false
};

function MainDashboardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_DASHBOARD_VIEWS: {
      return {
        ...state,
        viewError: false,
        viewSuccess: false
      };
    }
    case GET_DASHBOARD_VIEWS_SUCCESS: {
      return {
        ...state,
        views: action.views,
        defaultView: action.defaultView,
        viewSuccess: true,
        viewError: false
      };
    }
    case GET_DASHBOARD_VIEWS_ERROR: {
      return {
        ...state,
        views: [],
        viewSuccess: false,
        viewError: true
      };
    }
    case GET_DASHBOARD_SUCCESS: {
      return {
        ...state,
        currentView: action.view,
        currentLayout: action.cards.map(card => ({
          w: card.width,
          h: card.height,
          x: card.x,
          y: card.y,
          i: card.card_pk.toString(),
          minW: card.min_width,
          minH: card.min_height,
          maxW: card.max_width,
          maxH: card.max_height
        }))
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default combineReducers({
  MainDashboardReducer,
  RecentJobsReducer,
  JobPricingStatus,
  JobMatching,
  MarketIndex,
  OrganizationStatistics,
  RecentReports,
  SurveyActivity,
  SurveyUtilization
});
